import { render, staticRenderFns } from "./Publicacoes.vue?vue&type=template&id=3b6c7eee&scoped=true"
import script from "./Publicacoes.vue?vue&type=script&lang=js"
export * from "./Publicacoes.vue?vue&type=script&lang=js"
import style0 from "./Publicacoes.vue?vue&type=style&index=0&id=3b6c7eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c7eee",
  null
  
)

export default component.exports